import { Plugin } from '@ckeditor/ckeditor5-core';
import Tooltipediting from './tooltipediting';
import Tooltipui from './tooltipui';
import TooltipDisplay from './tooltipdisplay';

export default class Tooltip extends Plugin {
	static get requires() {
		return [Tooltipediting, Tooltipui, TooltipDisplay];
	}
}
